module.exports = __webpack_public_path__ + "img/pic.d1e01999.png";